import { useState } from "react";
import { renderToString } from "react-dom/server";
import Lightbox from "react-image-lightbox";
import "./Home.scss";
import "react-image-lightbox/style.css";
//import fileJson from "./../../components/Data/dataStatic__";

const Home = () => {
  /*const jss_image = fileJson;
  //const [image, insertImage] = useState([])
  var image = Array();
  Object.keys(jss_image).map((item) => {
    jss_image[item].forEach((element, index) => {
      image = [
        ...image,
        {
          id: index,
          name: element.image,
          category: item,
          name_project: element.name,
        },
      ];
    });
  });*/
  var ss = [
    {
      id: 0,
      name: "/static/media/moda_1.a95a19ccba498ebf4000.jpg",
      category: "moda",
      name_project: "Alto Las Condes Nocturno",
    },
    {
      id: 0,
      name: "/static/media/pyc_59.ca5e92482d2d05692dda.jpg",
      category: "productosycomida",
      name_project: "Pedro Juan y Diego",
    },
    {
      id: 0,
      name: "/static/media/retratos_5.fc5b1599f459e142afc9.jpg",
      category: "retratos",
      name_project: "Mirador del Alto",
    },
    {
      id: 1,
      name: "/static/media/moda_3.aaf0873456de3fc9d2e5.jpg",
      category: "moda",
      name_project: "Alto Las Condes Verano",
    },
    {
      id: 1,
      name: "/static/media/pyc_4.f815bfb5fa3b1780bb9e.jpg",
      category: "productosycomida",
      name_project: "Cafeteria",
    },
    {
      id: 1,
      name: "/static/media/retratos_9.cd20b3da92ab83b1ac7e.jpg",
      category: "retratos",
      name_project: "Hoteles Awasi",
    },
    {
      id: 2,
      name: "/static/media/moda_9.74373ec0c81f81a7f115.jpg",
      category: "moda",
      name_project: "Americanino",
    },
    {
      id: 2,
      name: "/static/media/pyc_43.faa1fd180c8f6e2ea842.jpg",
      category: "productosycomida",
      name_project: "Aceite de Oliva Soho",
    },
    {
      id: 2,
      name: "/static/media/retratos_2.736ea968b48dbea9865e.jpg",
      category: "retratos",
      name_project: "Compaq",
    },
    {
      id: 3,
      name: "/static/media/moda_32.3cab617a0e8da16dd3d1.jpg",
      category: "moda",
      name_project: "Elle Invierno",
    },
    {
      id: 3,
      name: "/static/media/pyc_38.6d5bc85e6c83a4915c42.jpg",
      category: "productosycomida",
      name_project: "Esso On the Run",
    },
    {
      id: 3,
      name: "/static/media/retratos_18.a1f404e7b9436854e53e.jpg",
      category: "retratos",
      name_project: "Banco Estado",
    },
    {
      id: 4,
      name: "/static/media/moda_36.d850f656adcaed35e470.jpg",
      category: "moda",
      name_project: "Johnson’s",
    },
    {
      id: 4,
      name: "/static/media/pyc_45.a1c784f05c5d9fa88809.jpg",
      category: "productosycomida",
      name_project: "Paula Cocina",
    },
    {
      id: 4,
      name: "/static/media/retratos_24.30655bf7f0797a5d42fb.jpg",
      category: "retratos",
      name_project: "Conapram",
    },
    {
      id: 5,
      name: "/static/media/moda_40.942005a1787d36a6cde9.jpg",
      category: "moda",
      name_project: "Lipton Iced tea",
    },
    {
      id: 5,
      name: "/static/media/pyc_13.aaac3cd0a9e1aad328e8.jpg",
      category: "productosycomida",
      name_project: "Verduras",
    },
    {
      id: 5,
      name: "/static/media/retratos_28.2e18b881c39c9279fb4f.jpg",
      category: "retratos",
      name_project: "Cine boys",
    },
    {
      id: 6,
      name: "/static/media/moda_43.f797ec75288e7287ca3b.jpg",
      category: "moda",
      name_project: "Luciana Dubini",
    },
    {
      id: 6,
      name: "/static/media/pyc_18.c2a7941217e8d1a8cf87.jpg",
      category: "productosycomida",
      name_project: "Test de luces",
    },
    {
      id: 6,
      name: "/static/media/retratos_24.30655bf7f0797a5d42fb.jpg",
      category: "retratos",
      name_project: "Proyecto 7",
    },
    {
      id: 7,
      name: "/static/media/moda_46.ede78414e348feed8b2c.jpg",
      category: "moda",
      name_project: "Prueba de Vestuario",
    },
    {
      id: 7,
      name: "/static/media/pyc_23.5afe3f7d342a6651a09d.jpg",
      category: "productosycomida",
      name_project: "Quesos",
    },
    {
      id: 7,
      name: "/static/media/retratos_31.13329bb2870f8efc634e.jpg",
      category: "retratos",
      name_project: "Caddies",
    },
    {
      id: 8,
      name: "/static/media/moda_57.16bceb23a1b1009b1189.jpg",
      category: "moda",
      name_project: "Thrift Shop",
    },
    {
      id: 8,
      name: "/static/media/pyc_29.2d473b8196e3bc4aa21b.jpg",
      category: "productosycomida",
      name_project: "Mercedes",
    },
    {
      id: 8,
      name: "/static/media/retratos_36.8b9457ffd949d85d5633.jpg",
      category: "retratos",
      name_project: "Maggi",
    },
    {
      id: 9,
      name: "/static/media/moda_62.23036aea07289415aaf1.jpg",
      category: "moda",
      name_project: "Pool boy",
    },
    {
      id: 9,
      name: "/static/media/pyc_44.aeca8a2ac032a6bad4b8.jpg",
      category: "productosycomida",
      name_project: "Panaderia",
    },
    {
      id: 9,
      name: "/static/media/retratos_42.d420142b16beeae21cba.jpg",
      category: "retratos",
      name_project: "Quiltros",
    },
    {
      id: 10,
      name: "/static/media/moda_64.7d68ddfce158a0fc8da1.jpg",
      category: "moda",
      name_project: "Ladrona y oso",
    },
    {
      id: 10,
      name: "/static/media/pyc_7.35c05d3049ebc44f12ac.jpg",
      category: "productosycomida",
      name_project: "Awasi Patagonia",
    },
    {
      id: 10,
      name: "/static/media/retratos_44.75d177ce401744843809.jpg",
      category: "retratos",
      name_project: "Claudia",
    },
    {
      id: 11,
      name: "/static/media/moda_66.462fb7bac70627d09586.jpg",
      category: "moda",
      name_project: "Bruna",
    },
    {
      id: 11,
      name: "/static/media/pyc_9.5ff5f015e1710b69fabb.jpg",
      category: "productosycomida",
      name_project: "Blanco en blanco",
    },
    {
      id: 11,
      name: "/static/media/retratos_45.60e14dbbef1bfb7ba5e2.jpg",
      category: "retratos",
      name_project: "Ian",
    },
    {
      id: 12,
      name: "/static/media/moda_67.241bca2548fcfb59df01.jpg",
      category: "moda",
      name_project: "Ripley Invierno",
    },
    {
      id: 12,
      name: "/static/media/pyc_10.9f3cb8dd2cac416cd093.jpg",
      category: "productosycomida",
      name_project: "Tasty",
    },
    {
      id: 12,
      name: "/static/media/retratos_46.264188383c1b3ea3bc14.jpg",
      category: "retratos",
      name_project: "Max",
    },
    {
      id: 13,
      name: "/static/media/moda_72.666de519a6749773a626.jpg",
      category: "moda",
      name_project: "Moda SEI",
    },
    {
      id: 13,
      name: "/static/media/pyc_20.2fce186a9a55235fc184.jpg",
      category: "productosycomida",
      name_project: "Green",
    },
    {
      id: 13,
      name: "/static/media/retratos_48.39ad78df8982469222e1.jpg",
      category: "retratos",
      name_project: "Classic",
    },
    {
      id: 14,
      name: "/static/media/moda_75.51f946c82f841d19a585.jpg",
      category: "moda",
      name_project: "Tanner",
    },
    {
      id: 14,
      name: "/static/media/pyc_34.f2523bc1f4fb65d6cd9a.jpg",
      category: "productosycomida",
      name_project: "Cosmetics",
    },
    {
      id: 14,
      name: "/static/media/retratos_53.91302a204c00cb13cd8a.jpg",
      category: "retratos",
      name_project: "Saturday Night Fever",
    },
    {
      id: 15,
      name: "/static/media/moda_76.72acfc3e760f6eb5e294.jpg",
      category: "moda",
      name_project: "Polaroid",
    },
    {
      id: 15,
      name: "/static/media/pyc_35.d28a332f5071d2fee0a0.jpg",
      category: "productosycomida",
      name_project: "Shu Uemura",
    },
    {
      id: 15,
      name: "/static/media/retratos_57.e1e65192d77be54cf9a1.jpg",
      category: "retratos",
      name_project: "Pancho Zegers / DDB",
    },
    {
      id: 16,
      name: "/static/media/moda_77.6285d92a29446921a763.jpg",
      category: "moda",
      name_project: "Jose Luis",
    },
    {
      id: 16,
      name: "/static/media/pyc_28.ad51dc9bc46334d472cf.jpg",
      category: "productosycomida",
      name_project: "Limelight",
    },
    {
      id: 16,
      name: "/static/media/retratos_1.0f05d93e1ca988c6b11b.jpg",
      category: "retratos",
      name_project: "FOL",
    },
    {
      id: 17,
      name: "/static/media/moda_12.abe123d9c2e648582aec.jpg",
      category: "moda",
      name_project: "Tonka",
    },
    {
      id: 17,
      name: "/static/media/pyc_32.ff5488a24dfd53aa1353.jpg",
      category: "productosycomida",
      name_project: "Coaniquem",
    },
    {
      id: 17,
      name: "/static/media/retratos_3.e2144ba226716e049737.jpg",
      category: "retratos",
      name_project: "Eso",
    },
    {
      id: 18,
      name: "/static/media/moda_13.32cc715d0a752f54c046.jpg",
      category: "moda",
      name_project: "Soft",
    },
    {
      id: 18,
      name: "/static/media/pyc_33.de1cbc81f74e954fd2af.jpg",
      category: "productosycomida",
      name_project: "Tie",
    },
    {
      id: 18,
      name: "/static/media/retratos_41.0037982ae0221dfe5039.jpg",
      category: "retratos",
      name_project: "Jaime",
    },
    {
      id: 19,
      name: "/static/media/moda_15.4272ac9c1963d7a09f0b.jpg",
      category: "moda",
      name_project: "Bernardita",
    },
    {
      id: 19,
      name: "/static/media/pyc_37.778435c9a275ca4fe071.jpg",
      category: "productosycomida",
      name_project: "Connected",
    },
    {
      id: 19,
      name: "/static/media/retratos_47.6761a0ddef227e85240c.jpg",
      category: "retratos",
      name_project: "Nicolás",
    },
    {
      id: 20,
      name: "/static/media/moda_17.41083dcfdfd147712f36.jpg",
      category: "moda",
      name_project: "White skin",
    },
    {
      id: 20,
      name: "/static/media/pyc_48.9e247936631b790b7192.jpg",
      category: "productosycomida",
      name_project: "Aceite Huasco",
    },
    {
      id: 21,
      name: "/static/media/moda_20.6cc45d49ce7ddb3007b0.jpg",
      category: "moda",
      name_project: "Garage Light",
    },
    {
      id: 21,
      name: "/static/media/pyc_54.8530a6851407efa8f599.jpg",
      category: "productosycomida",
      name_project: "Brasas",
    },
    {
      id: 22,
      name: "/static/media/moda_24.1d7e9e979db61e762c8a.jpg",
      category: "moda",
      name_project: "Chocolate filter",
    },
    {
      id: 22,
      name: "/static/media/pyc_52.8cccd16654c273775aff.jpg",
      category: "productosycomida",
      name_project: "Lota",
    },
    {
      id: 23,
      name: "/static/media/moda_26.919e164c44cef3cb911b.jpg",
      category: "moda",
      name_project: "Dayane",
    },
    {
      id: 23,
      name: "/static/media/pyc_63.b889e4d985c4ee93a20d.jpg",
      category: "productosycomida",
      name_project: "Proyecto 24",
    },
    {
      id: 24,
      name: "/static/media/moda_29.9b8698ff310970f0c9e9.jpg",
      category: "moda",
      name_project: "Fresnel light",
    },
    {
      id: 25,
      name: "/static/media/moda_28.3d687f14f6bba44618b3.jpg",
      category: "moda",
      name_project: "Elite beauty",
    },
  ];
  /*var out = new Array(image.length).fill(1).map(function (val) {
    var random = Math.floor(Math.random() * image.length);
    console.info(out)
    return {
      name: image[random]?.name,
      proyect: image[random]?.proyect,
      id: image[random]?.id,
    };
  });

  console.log(out);*/
  /*while (image.length < 50) {
    var numeroAleatorio = Math.ceil(Math.random() * image.length);
    var existe = false;
    for (var i = 0; i < image.length; i++) {
      if (image[i] === numeroAleatorio) {
        existe = true;
        break;
      }
    }
    if (!existe) {
      image[image.length] = numeroAleatorio;
    }
  }*/
  /*let aleatorio = image2
    .fill()
    .map(() => (Math.round(Math.random() * image.length) ? <></> : <></>));¨*/
  const [show, isOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [photoProject, setPhotoProject] = useState("");
  const handleClick = (project, index) => {
    console.info(project);
    isOpen(true);
    setPhotoIndex(index);
    setPhotoProject(project);
  };
  let number = 1;
  const order = (key) => {
    number++;
    if (number === 3) {
      number = 0;
      if (key === 1) {
        return "max";
      }
      return "top";
    }
    return "";
  };
  const LinkCaption = ({ id, name, name_project, category }) => {
    return (
      <div className="caption">
        <div className="container">
          <div className="row">
            <div className="col-6">{name_project}</div>
            <div className="col-6">
              <a href={`proyecto/${category}/${id}`}>
                <span className="button">Ver Proyecto</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className="container">
      <div className="main">
        <div className={`content_proyect container`}>
          <div className="row">
            {ss.map((i, k) => (
              <div className="col-12 col-sm-6 col-md-4" key={k}>
                <div className={`recuadro ${order(k)}`}>
                  <img
                    src={i.name}
                    onClick={(e) => {
                      handleClick(i, k);
                    }}
                    alt=""
                  />
                </div>
              </div>
            ))}
            {/*fileJson &&
              Object.keys(s_).map((item) =>
                fileJson[item].map((i, k) => (
                  <div className="col-12 col-sm-6 col-md-4" key={k}>
                    <div className={`recuadro ${order(k)}`}>
                      <img
                        src={i?.image}
                        onClick={(e) => {
                          handleClick(item, k);
                        }}
                        alt=""
                      />
                    </div>
                  </div>
                ))
                      )*/}
            {show && (
              <Lightbox
                mainSrc={ss[photoIndex]?.name}
                nextSrc={ss[(photoIndex + 1) % ss.length]?.name}
                prevSrc={ss[(photoIndex + ss.length - 1) % ss.length]?.name}
                imageCaption={
                  <div
                    dangerouslySetInnerHTML={{
                      __html: renderToString(
                        <LinkCaption {...ss[photoIndex]} />
                      ),
                    }}
                  ></div>
                }
                onCloseRequest={() => isOpen(false)}
                onMovePrevRequest={() =>
                  setPhotoIndex((photoIndex + ss.length - 1) % ss.length)
                }
                onMoveNextRequest={() =>
                  setPhotoIndex((photoIndex + 1) % ss.length)
                }
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Home;
